import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import cartApi from '../../api/cartApi';
import couponsApi from '../../api/couponsApi';

const Cart = () => {
  const { user, removeFromCart, loadCart } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);

  useEffect(() => {
    if (!user) { navigate('/', { replace: true }); return; }
    if (user?.id) {
      setLoading(true);
      loadCart().finally(() => setLoading(false));
    }
    console.log("asasas", user)
  }, [user?.id, navigate]);

  if (!user) return null;

  if (loading) return <div style={{ padding: 20, textAlign: 'center' }}>טוען מוצרים בסל...</div>;

  const items = user?.cart || [];


  const handleRemove = async (itemId) => {
    await removeFromCart(itemId);
  };

  const toggleItemExpansion = (itemId) => {
    setExpandedItem(expandedItem === itemId ? null : itemId);
  };

  return (
    <div className="cart-container">
      <div className="cart-header">
        <button style={{ border: "1px solid #0cad5e", color:"#0cad5e"}} onClick={() => navigate('/profile')} className="back-button">← חזרה לאזור אישי</button>
 <h3 style={{
  color: "#0cad5e",
  display: "flex",
  justifyContent: "center",
  // alignItems: "center",
  gap: "8px"   // קצת רווח בין הכותרת לאייקון
}} > סל קניות ({items.length})
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0cad5e"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
      </h3>      </div>

      {items.length === 0 && (
        <div className="cart-empty">
          <div className="empty-icon">🛒</div>
          <div className="empty-text">הסל שלך ריק</div>
          <div className="empty-subtext">הוסף מוצרים לסל כדי להתחיל בקניות</div>
        </div>
      )}

      {items.length > 0 && (
        <>
          <div className="cart-items-list">
            {items.map(it => (
              <div key={it.id} className="cart-item-card">
                
                <div className="cart-item-header" onClick={() => toggleItemExpansion(it.id)}>
                  <div className="cart-item-basic">
                  <div className="cart-item-actions">
                    <button className="cart-expand-btn">{expandedItem === it.id ? '▼' : '▶'}</button>
                    <button className="cart-remove-btn" onClick={(e) => { e.stopPropagation(); handleRemove(it.id); }}>הסר</button>                  
                  </div>
                    
                    <div className="cart-item-info">
                      <div className="cart-item-name">{it.name}</div>
                      <div className="cart-item-price">₪ מחיר: {it.price} </div>
                    </div>
                    <div className="cart-item-thumb">
                      <img src={(it.url) || ''} alt={it.name} />
                    </div>
                  <div className="cart-item-actions">
                  </div>
                  </div>

                </div>
                {expandedItem === it.id && (
                  <div className="cart-item-details">
                    <div className="cart-item-description">
                      {it.description && <p>{it.description}</p>}
                      {it.features && it.features.length > 0 && (
                        <div className="cart-item-features">
                          <strong>תכונות:</strong>
                          <div className="features-list">
                            {it.types.map(f => <span key={f.id} className="feature-tag">{f.name}</span>)}
                          </div>
                        </div>
                      )}
                      {it.much_for && <p><strong>מתאים ל:</strong> {it.much_for}</p>}
                      {it.video && <p> כולל קטעי מסך
                        <p><svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="#0cad5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" />
                    <polygon points="10,8 16,12 10,16" />
                  </svg></p>
                      </p> }
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="cart-checkout-section">
            <button className="cart-checkout-btn" onClick={() => navigate('/profile/checkout')}>
              מעבר לקופה ({items.length} מוצרים)
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
